import { useLocation } from '@reach/router';

const useCurriculumDownload = () => {
  const EPaths = {
    FSD: '/software-development-fellowship-program',
    QA: '/qa-automation-testing',
    ACCELERATE: '/accelerate',
    DATA_ANALYTICS: '/ai-data-analytics',
    SYSTEM_DESIGN: '/fellowship-program-system-design',
    SKILLQ_FULL_STACK_DEVELOPMENT_PROGRAM:
      '/skillq-full-stack-development-program',
    SKILLQ_DATA_ANALYTICS_PROGRAM: '/skillq-data-analytics-program',
    SKILLQ_QA_AUTOMATION_PROGRAM: '/skillq-qa-automation-program',
  };

  const location = useLocation();

  const downloadCurriculum = () => {
    const pathname = location.pathname;
    let downloadLink =
      'https://crio-assets.s3.ap-south-1.amazonaws.com/FSD_Handbook.pdf';

    if (pathname.includes(EPaths.FSD)) {
      downloadLink =
        'https://crio-assets.s3.ap-south-1.amazonaws.com/FSD_Handbook.pdf';
    } else if (pathname.includes(EPaths.QA)) {
      downloadLink =
        'https://crio-assets.s3.ap-south-1.amazonaws.com/QA_Handbook.pdf';
    } else if (pathname.includes(EPaths.ACCELERATE)) {
      downloadLink =
        'https://crio-assets.s3.ap-south-1.amazonaws.com/Accelerate_Handbook.pdf';
    } else if (pathname.includes(EPaths.DATA_ANALYTICS)) {
      downloadLink =
        'https://crio-assets.s3.ap-south-1.amazonaws.com/Data_Analytics_Handbook.pdf';
    } else if (pathname.includes(EPaths.SYSTEM_DESIGN)) {
      downloadLink =
        'https://crio-assets.s3.ap-south-1.amazonaws.com/System_Design_Handbook.pdf';
    } else if (
      pathname.includes(EPaths.SKILLQ_FULL_STACK_DEVELOPMENT_PROGRAM)
    ) {
      downloadLink =
        'https://crio-assets.s3.ap-south-1.amazonaws.com/SkillQ_FSD_Handbook.pdf';
    } else if (pathname.includes(EPaths.SKILLQ_DATA_ANALYTICS_PROGRAM)) {
      downloadLink =
        'https://crio-assets.s3.ap-south-1.amazonaws.com/SkillQ_DA_Handbook.pdf';
    } else if (pathname.includes(EPaths.SKILLQ_QA_AUTOMATION_PROGRAM)) {
      downloadLink =
        'https://crio-assets.s3.ap-south-1.amazonaws.com/SKILLQ_QA_Handbook.pdf';
    } else {
      downloadLink =
        'https://crio-assets.s3.ap-south-1.amazonaws.com/FSD_Handbook.pdf';
    }

    if (downloadLink) {
      window.open(downloadLink, '_blank');
    }

    return '';
  };

  return { downloadCurriculum };
};

export default useCurriculumDownload;
